export default __webpack_public_path__ + "static/media/cipla.03e5ab5f.png";